(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsEnumSelector', rmsEnumSelector);

    function rmsEnumSelector() {
        return {
            restrict: 'E',
            controller: rmsEnumSelectorCtrl,
            controllerAs: 'vm',
            bindToController: true,
            require: 'ngModel',
            scope: {
                name: '@',
                config: '=?'
            },
            template: `<selectize config="vm.selectConfig" options='vm.ds' ng-model="vm.selected"></selectize>`,
            link: rmsEnumSelectorLink
        };

        function rmsEnumSelectorLink(scope, elem, link, ngModelCtrl) {
            const vm = scope.vm;
            vm.ngModelCtrl = ngModelCtrl;

            vm.ngModelCtrl.$render = function() {
                vm.selected = vm.ngModelCtrl.$viewValue;
            };

        }
    }

    function rmsEnumSelectorCtrl(RmsEnum, $q) {
        var vm = this;
        this.$onInit = function() {
            $q.when(RmsEnum.getList(vm.name)).then(function(ds) {
                vm.ds = ds;
            });
            vm.config = (vm.config === undefined) ? {} : vm.config;

            vm.selectConfig = angular.merge(
                {
                    create: false,
                    valueField: 'value',
                    labelField: 'label',
                    maxItems: 1,
                    onChange: function(value) {
                        vm.ngModelCtrl.$setViewValue(value);
                    }
                },
                vm.config
            )
        }
    }
})();